export const DESTINATIONS = [
  {
    city: "Santorini",
    country: "Greece",
    code: "JTR",
    from: 1899,
    img: "https://images.unsplash.com/photo-1498503403619-e39e4ff390fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZGVzdGluYXRpb24lMjB0cmF2ZWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgwMDUzOTYyfDA&ixlib=rb-4.1.0&q=85",
    tagline: "Whitewashed cliffs above an Aegean caldera.",
    description: "Few skylines on earth are as instantly recognisable as Oia's — sugar-cube houses and cobalt domes stacked against a thousand-foot caldera, the Aegean glinting below. Mornings are for clifftop swimming pools and warm fava with capers; evenings belong to the sunset, when the entire island leans west.",
    best_for: ["Honeymoons", "Caldera sunsets", "Cycladic architecture"],
    region: "Cyclades, Greece",
    typical_flight_hours: 11,
    season: "May–October",
  },
  {
    city: "Manarola",
    country: "Italy",
    code: "GOA",
    from: 1499,
    img: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwZGVzdGluYXRpb24lMjB0cmF2ZWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgwMDUzOTYyfDA&ixlib=rb-4.1.0&q=85",
    tagline: "The most photographed corner of the Cinque Terre.",
    description: "Manarola is the second-smallest village of the Cinque Terre, and arguably the most painterly. Pastel houses tumble down a vertical cliff into a tiny fishing harbour, vineyards terrace the hillside above, and the entire scene glows pink at golden hour. Pair the via dell'Amore walk to Riomaggiore with a chilled glass of Sciacchetrà.",
    best_for: ["Coastal hiking", "Italian Riviera escapes", "Slow food"],
    region: "Liguria, Italy",
    typical_flight_hours: 9,
    season: "April–June, September",
  },
  {
    city: "Paris",
    country: "France",
    code: "CDG",
    from: 1199,
    img: "https://images.pexels.com/photos/15799653/pexels-photo-15799653.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Light, art, fashion — the city that wrote the playbook.",
    description: "Paris rewards attention. Spend a morning with the Caillebottes at the Musée d'Orsay, a long lunch in the Marais, and an evening tracing the Seine from Pont Neuf to the Eiffel Tower as the hourly light show begins. The premium-cabin schedule into CDG is among the deepest in the world — there's almost always a great fare somewhere.",
    best_for: ["Art & museums", "Michelin dining", "Long-weekend luxury"],
    region: "Île-de-France, France",
    typical_flight_hours: 7,
    season: "April–June, September–October",
  },
  {
    city: "Tashkent",
    country: "Uzbekistan",
    code: "TAS",
    from: 1799,
    img: "https://images.pexels.com/photos/37431912/pexels-photo-37431912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Silk Road heritage meets Soviet modernism.",
    description: "Tashkent is the gateway to the great Silk Road cities — Samarkand, Bukhara, Khiva — but the capital itself deserves a long stay. Blue-tiled madrasas sit a metro stop from brutalist Soviet plazas; the bazaar at Chorsu smells of cumin and grilled lamb; and the Uzbek welcome is unmistakably warm. One of the most under-rated long-haul destinations our desk books.",
    best_for: ["Cultural depth", "Silk Road circuits", "Off-the-beaten-path"],
    region: "Central Asia",
    typical_flight_hours: 14,
    season: "April–June, September–November",
  },
];

export const DEALS = [
  {
    title: "New York → Tokyo",
    fare: "Business Class",
    price: 3299,
    nights: "7 nights",
    img: "https://images.pexels.com/photos/16340931/pexels-photo-16340931.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    badge: "Limited"
  },
  {
    title: "Los Angeles → Paris",
    fare: "First Class",
    price: 4899,
    nights: "10 nights",
    img: "https://images.unsplash.com/photo-1594937113195-27f8b9046013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmaXJzdCUyMGNsYXNzJTIwZmxpZ2h0JTIwd2luZG93JTIwc3Vuc2V0fGVufDB8fHx8MTc4MDA1Mzk2Mnww&ixlib=rb-4.1.0&q=85",
    badge: "Exclusive"
  },
  {
    title: "Miami → Santorini",
    fare: "Premium Economy",
    price: 1899,
    nights: "5 nights",
    img: "https://images.unsplash.com/photo-1498503403619-e39e4ff390fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZGVzdGluYXRpb24lMjB0cmF2ZWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgwMDUzOTYyfDA&ixlib=rb-4.1.0&q=85",
    badge: "Save 24%"
  },
];

export const TESTIMONIALS = [
  {
    quote: "Booking our anniversary trip through TheCityPair was effortless. The concierge upgraded our seats and the trip was flawless.",
    name: "Eleanor M.",
    title: "New York, NY",
  },
  {
    quote: "Their fares on business class to Europe consistently undercut every other premium platform I've used. I won't book anywhere else.",
    name: "James R.",
    title: "San Francisco, CA",
  },
  {
    quote: "The 24/7 travel assistance saved our connection when our first flight was delayed. They rebooked us in minutes.",
    name: "Priya S.",
    title: "Chicago, IL",
  },
];

export const PARTNER_LOGOS = [
  "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/fb5fed738cc52c7ff0ffe401650da25aed96c98f672f32b9478915cb2045bd03.png",
  "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/207a1a35afae26cc3d5db711286129c6095444fbba29ea5fd1647f31e63196e9.png",
  "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/6ae79d06917c138cc0282c0e205b166f39f1c2ebc30aff39b854ae7eedea46e7.png",
];

export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/b3842ade198b99c23100c61b21ee3f88e7ccc2c4368bb1e3225a456a499c57a5.png";
export const TEXTURE_IMG = "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/6c82b8839678183f95b4a3afc76880de645a4837fc55e57c553b4d80581e9ff1.png";
export const LIFESTYLE_IMG = "https://static.prod-images.emergentagent.com/jobs/71ab0464-cf3b-415a-a6d0-48b9c6dce340/images/f5dade6759c54f1b62c3864df9215183551a6058dabad8653148c2190ca1f594.png";
export const LOGO_URL = "/logo-tcp.png";
